import { authenticatedFetch } from '../utils/api';
import { API_HOST } from '../utils/constants';

const request = (action, body, signal) => authenticatedFetch(`${API_HOST}/api/modelark/assets/${action}`, {
  method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal,
});

export const readModelArkAssetStatus = (body, signal) => request('status', body, signal);
export const registerModelArkAssets = (body) => request('register', body);
export const recheckModelArkAssets = (body) => request('recheck', body);
